// extracted by mini-css-extract-plugin
module.exports = {"drop-zone":"styles_drop-zone__22QBt","drop-zone__content":"styles_drop-zone__content__3-YX4","drop-zone__text":"styles_drop-zone__text__33Vwr"};